/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Comments, Comment } from '../../data/interfaces'
import {
    FETCH_API_COMMENTS_REQUEST, FETCH_API_COMMENTS_SUCCESS, FETCH_API_COMMENTS_FAILURE,
    POST_COMMENT_REQUEST, POST_COMMENT_SUCCESS, POST_COMMENT_FAILURE,
    DELETE_COMMENT_REQUEST, DELETE_COMMENT_SUCCESS, DELETE_COMMENT_FAILURE, CommentActions, 
    EDIT_COMMENT_FAILURE, EDIT_COMMENT_REQUEST, EDIT_COMMENT_SUCCESS
} from '../types/comments'

interface CommentsState {
    loading: boolean,
    comments: Comments,
    error: string,
}

const initialState: CommentsState = {
    loading: true,
    comments: { count: 0, list: [], pagination: null },
    error: ''
}

const apiCommentsReducer = (state = initialState, action: CommentActions) => {
    switch (action.type) {
        case FETCH_API_COMMENTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }
        case FETCH_API_COMMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                comments: action.payload,
                error: ''
            }
        case FETCH_API_COMMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                comments: { count: 0, list: [], pagination: null },
                error: action.payload
            }
        case POST_COMMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case POST_COMMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                comments: {
                    ...state.comments,
                    list: [action.payload, ...state.comments.list],
                    count: state.comments.count + 1
                }
            }
        case POST_COMMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case DELETE_COMMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case DELETE_COMMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                comments: {
                    ...state.comments,
                    list: state.comments.list.filter( comment => comment.id !== action.payload),
                    count: state.comments.count - 1
                }
            }
        case DELETE_COMMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case EDIT_COMMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case EDIT_COMMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                comments: {
                    ...state.comments,
                    list: [action.payload, ...state.comments.list.filter(comment => comment.id !== (action.payload as unknown as Comment).id)],
                }
            }
        case EDIT_COMMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default: return state
    }
}

export default apiCommentsReducer;
